window.addEventListener('DOMContentLoaded', () => {
  class Accordion {
    constructor(item, index) {
      this.item = item;
      this.title = this.item.querySelector('.dropdown__title');
      this.content = this.item.querySelector('.dropdown__content');
      this.dropdownContent = this.item.querySelector('.dropdown__content_reception');
      if (this.dropdownContent) {
        this.hasP = !!this.dropdownContent.querySelector('p');
      }

      this.setupEventListeners();

      if (index === 0) {
        this.content.style.display = 'block';
        this.title.classList.add('active');
      }

      if (this.item.hasAttribute('data-first-close')) {
        this.content.style.display = 'none';
        this.title.classList.remove('active');
      }
    }

    toggleContent(e) {
      if (e.target.tagName === 'path') {
        return;
      }

      if (this.title.tagName === 'A') {
        return;
      }


      if (!this.hasP && this.hasP != undefined) {
        return;
      }

      if (this.content.style.display === 'none' || this.content.style.display === '') {
        this.content.style.display = 'block';
        this.title.classList.add('active');
      }
      else {
        this.content.style.display = 'none';
        this.title.classList.remove('active');
      }

    }

    setupEventListeners() {
      const newTitle = this.title.cloneNode(true);
      this.title.parentNode.replaceChild(newTitle, this.title);
      this.title = newTitle;
      this.title.addEventListener('click', this.toggleContent.bind(this));
    }

  }

  const initAccordions = (container) => {
    const accordionItems = container.querySelectorAll('.dropdown__inner');
    const accordions = [];

    accordionItems.forEach((item, index) => {
      const accordion = new Accordion(item, index);
      accordions.push(accordion);
    });
  };

  initAccordions(document.body);
  window.initAccordions = initAccordions;
});
